import { orderType } from '../../types/order/orderType';
import { request } from '../../utils/request';

type ReturnType = {
  store_id: string;
  filters: {
    product_id?: string;
    status?: string;
  };
  orders: Array<orderType>;
};

export const markOrderAsPackaged = ({
  authToken,
  reference,
  storeId,
}: {
  storeId: number;
  authToken: string;
  reference: orderType['reference'];
}): Promise<ReturnType> => {
  return request({
    method: 'PATCH',
    url: `/payments/products/orders/${reference}/packed`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    formData: {
      storeId,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
};
